import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.ul`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;

  ${({ theme }) => theme.media.mobile} {
    margin-top: 20px;
  }
`;

export const Legend = styled.li`
  display: flex;
  margin-right: 14px;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray800};
  ${getFontStyle('midium120_C1')};

  &::before {
    content: '';
    display: block;
    width: 9px;
    height: 9px;
    margin-right: 7px;
    width: 15px;
    height: 3px;
    background: ${({ theme }) => theme.colors.magenta500};
  }

  ${({ theme }) => theme.media.mobile} {
    margin-right: 44px;
  }

  &:last-child {
    margin-right: 0;
  }
`;
